export enum AUTH_OPTION_TYPES {
  USER_STATUS = 1,
  GENDER = 2,
  ORGANIZATION_UNIT_CLASSIFY = 3,
  USER_GROUP_CLASSIFY = 4
}
